module.exports = __webpack_public_path__ + "static/media/trash.6bf16bf0.svg";